module.exports = __webpack_public_path__ + "static/media/elo.72af2dc0.svg";